import { render } from "./Mitigationdetailsmodal.vue?vue&type=template&id=7dede84a&scoped=true"
import script from "./Mitigationdetailsmodal.js?vue&type=script&lang=js"
export * from "./Mitigationdetailsmodal.js?vue&type=script&lang=js"

import "./Mitigationdetailsmodal.vue?vue&type=style&index=0&id=7dede84a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dede84a"]])

export default __exports__